var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"layout-custom"},[_c('header-nav'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view'),_c('v-spacer',{staticClass:"mb-12"})],1)],1),_c('snackbar'),_c('loading'),_c('footer-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }